import config from '../config';

export const AssociateFLSCard = (
  profileAuth: { sessionId: string; token: string },
  cardNumber: string,
  associatedCardPhone: string,
  updateNewsletterConsent: boolean
): Promise<any> => {
  const domain = config.FLS_API_DOMAIN || '';

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + profileAuth.token },
    body: JSON.stringify({
      CardNumber: cardNumber,
      Phone: associatedCardPhone,
      sessionId: profileAuth.sessionId,
      UpdateNewsletterConsent: updateNewsletterConsent,
    }),
  };

  return fetch(domain + '/api/Card/Associate', requestOptions);
};

export const ReplaceFLSCardResponse = (
  profileAuth: { sessionId: string; token: string },
  newCardNumber: string
): Promise<any> => {
  const domain = config.FLS_API_DOMAIN || '';

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + profileAuth.token },
    body: JSON.stringify({
      NewCardNumber: newCardNumber,
      sessionId: profileAuth.sessionId,
    }),
  };

  return fetch(domain + '/api/Card/Replace', requestOptions);
};
